import { number } from 'mathjs';

export const encode_bag_info = (bag_info) =>
  [
    `${bag_info.quantity || 1}`,
    `${String(bag_info.weight || '')}${bag_info.weight ? bag_info.weightUnit || 'kg' : ''}`,
  ]
    .filter((e) => e.length !== 0)
    .join(':');

export const decode_bag_info = (bag_info) => {
  try {
    if (String(bag_info).length > 0) {
      const parts = String(bag_info).split(':');
      return {
        quantity: number(parts.length > 0 ? parts[0] : 1),
        weight: parts.length > 1 ? parts[1] : undefined,
      };
    }
  } catch {
    // EMPTY
  }
  return { quantity: 1, weight: undefined };
};

/**
 * Reconstruct a `flexible_bags`-shaped tree from the offer's persisted
 * FareDetailAdditionalService[] entries. Confirm/checkout views may load
 * without the pre-book Vuex `liveflight.flexible_bags` slice (deep link,
 * refresh, post-payment landing); selections always survive on the offer
 * because `fold_committed_ancillaries` stamps them onto
 * travelerPricings[].fareDetailsBySegment[] at confirm/retrieve.
 * @param {Object} flight_offer
 * @returns {Object}
 */
export const flexible_bags_from_offer = (flight_offer) => {
  const { travelerPricings = [], itineraries = [] } = flight_offer || {};

  const segment_to_itinerary = {};
  itineraries.forEach((itinerary, itinerary_index) => {
    const { segments = [] } = itinerary || {};
    segments.forEach((segment) => {
      const { id = '' } = segment || {};
      if (id) segment_to_itinerary[id] = String(itinerary_index);
    });
  });

  const result = {};
  travelerPricings.forEach((pricing, traveler_index) => {
    const { fareDetailsBySegment = [] } = pricing || {};
    const traveler_key = String(traveler_index);
    fareDetailsBySegment.forEach((fare_detail) => {
      const { segmentId = '', additionalServices = [] } = fare_detail || {};
      const itinerary_key = segment_to_itinerary[segmentId];
      if (itinerary_key === undefined) return;
      const list = Array.isArray(additionalServices) ? additionalServices : [];
      list.forEach((entry, entry_index) => {
        const { type = '', id = '', quantity, weight, weightUnit = '', name = '' } = entry || {};
        if (type !== 'bag') return;
        if (!Number(quantity || 0)) return;
        const bag_key = id || `${segmentId}:${entry_index}`;
        if (!result[traveler_key]) result[traveler_key] = {};
        if (!result[traveler_key][itinerary_key]) result[traveler_key][itinerary_key] = {};
        const existing = result[traveler_key][itinerary_key][bag_key];
        if (existing) {
          const { bag = {} } = existing;
          const { segmentIds = [] } = bag;
          if (!segmentIds.includes(segmentId)) bag.segmentIds = [...segmentIds, segmentId];
          return;
        }
        const bag = { quantity: Number(quantity), segmentIds: [segmentId] };
        if (id) bag.id = id;
        if (name) bag.name = name;
        if (weight !== undefined) bag.weight = Number(weight);
        if (weightUnit) bag.weightUnit = weightUnit;
        result[traveler_key][itinerary_key][bag_key] = { added: true, bag };
      });
    });
  });
  return result;
};
